export function capitalize(string) {
  if (typeof string !== "string") return ""

  return string?.toLowerCase().replace(/\b(\w)/g, (s) => s.toUpperCase())
}
